// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1Kvi0","tab":"ProcedureTabs_tab__2cpzV"};